"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = exports.Label = exports.TimePicker = exports.DatePicker = exports.Radio = exports.Checkbox = exports.Input = exports.Select = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Checkbox_1 = require("./form/Checkbox");
var Radio_1 = require("./form/Radio");
var Select_1 = require("./form/Select");
var DatePicker_1 = require("./form/DatePicker");
var Input_1 = require("./form/Input");
var TimePicker_1 = require("./form/TimePicker");
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var colors_1 = require("../util/colors");
var TextArea_1 = require("./TextArea");
exports.Select = Select_1.Select;
exports.Input = Input_1.Input;
exports.Checkbox = Checkbox_1.Checkbox;
exports.Radio = Radio_1.Radio;
exports.DatePicker = DatePicker_1.DatePicker;
exports.TimePicker = TimePicker_1.TimePicker;
exports.Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  ", "\n"], ["\n  font-family: ", ";\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.baseType;
}, typography_1.rulesForTextProps);
var FieldWrapper = (0, styled_components_1.default)(grid_1.Container)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  border-radius: 8px;\n"], ["\n  ", "\n  border-radius: 8px;\n"])), function (_a) {
    var fillBg = _a.fillBg;
    return (fillBg ? "background-color: ".concat(colors_1.colors.gray50, ";") : '');
});
var FormField = function (_a) {
    var label = _a.label, field = _a.field, value = _a.value, checked = _a.checked, onChange = _a.onChange, onValidityChange = _a.onValidityChange, help = _a.help, placeholder = _a.placeholder, apiBase = _a.apiBase, options = _a.options, error = _a.error, autoComplete = _a.autoComplete, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.inputType, inputType = _c === void 0 ? 'text' : _c, children = _a.children, pickerProps = _a.pickerProps, containerProps = _a.containerProps, _d = _a.required, required = _d === void 0 ? false : _d, inputMode = _a.inputMode, passThroughProps = _a.passThroughProps, pattern = _a.pattern, isValid = _a.isValid, invalidErrorMsg = _a.invalidErrorMsg, wrapperProps = __rest(_a, ["label", "field", "value", "checked", "onChange", "onValidityChange", "help", "placeholder", "apiBase", "options", "error", "autoComplete", "disabled", "inputType", "children", "pickerProps", "containerProps", "required", "inputMode", "passThroughProps", "pattern", "isValid", "invalidErrorMsg"]);
    var _e = (0, react_1.useState)(null), invalidReason = _e[0], setInvalidReason = _e[1];
    var baseNativeProps = {
        disabled: disabled,
        placeholder: placeholder,
        autoComplete: autoComplete,
        inputMode: inputMode,
        onBlur: function (e) {
            if ((pattern && !pattern.test(e.target.value)) ||
                (isValid && !isValid(e.target.value))) {
                setInvalidReason(invalidErrorMsg || "Please enter a valid ".concat(field));
                onValidityChange({ field: field, valid: false });
            }
        },
        onChange: function (e) {
            onChange && onChange({ field: field, value: e.target.value });
            if ((pattern && pattern.test(e.target.value)) ||
                (isValid && isValid(e.target.value))) {
                setInvalidReason(null);
                onValidityChange({ field: field, valid: true });
            }
        },
        name: field,
    };
    var nativeProps = __assign(__assign({}, baseNativeProps), { defaultValue: value });
    var errorMessage = invalidReason || (typeof error === 'string' && error);
    var styleProps = { error: !!(error || invalidReason) };
    var selectable = ['radio', 'checkbox'].includes(inputType);
    var requiredPrefix = required && react_1.default.createElement(typography_1.Text, { color: colors_1.colors.red600 }, "* ");
    return (react_1.default.createElement(FieldWrapper, __assign({ direction: "column" }, wrapperProps, { grow: true }),
        !selectable && label && (react_1.default.createElement(spacing_1.Div, { pb: 1 },
            react_1.default.createElement(exports.Label, { weight: 500 },
                requiredPrefix,
                label))),
        children && !selectable ? children : null,
        ['text', 'password'].includes(inputType) && (react_1.default.createElement(exports.Input, __assign({ styledProps: styleProps }, __assign(__assign({}, nativeProps), { type: inputType })))),
        inputType === 'select' ? (react_1.default.createElement(Select_1.Select, __assign({ options: options, styledProps: styleProps }, nativeProps))) : null,
        inputType === 'multiLineText' ? (react_1.default.createElement(TextArea_1.TextArea, { styledProps: styleProps, nativeProps: nativeProps })) : null,
        inputType === 'time' ? (react_1.default.createElement(exports.TimePicker, __assign({ onChange: function (value) { return onChange && onChange({ field: field, value: value }); }, styledProps: styleProps }, passThroughProps, nativeProps))) : null,
        inputType === 'date' ? (react_1.default.createElement(exports.DatePicker, __assign({ styledProps: styleProps, onDateChange: function (value) { return onChange && onChange({ field: field, value: value }); }, pickerProps: pickerProps }, nativeProps))) : null,
        inputType === 'checkbox' && (react_1.default.createElement(grid_1.Container, { p: wrapperProps.fillBg ? 2 : 0, align: "center", grow: true },
            react_1.default.createElement(exports.Checkbox, __assign({ styledProps: styleProps }, __assign(__assign({}, baseNativeProps), { defaultChecked: checked !== undefined ? checked : !!value, onChange: function (e) {
                    return onChange && onChange({ field: field, value: e.target.checked });
                } }), { containerProps: containerProps }), children
                ? children
                : label && (react_1.default.createElement(exports.Label, null,
                    requiredPrefix,
                    label))))),
        inputType === 'radio' && (react_1.default.createElement(grid_1.Container, { p: wrapperProps.fillBg ? 2 : 0, align: "center", grow: true },
            react_1.default.createElement(exports.Radio, __assign({ styledProps: styleProps }, __assign(__assign({}, baseNativeProps), { value: value, defaultChecked: checked, onChange: function (e) { return onChange && onChange({ field: field, value: value }); } }), { containerProps: containerProps }), children
                ? children
                : label && (react_1.default.createElement(exports.Label, null,
                    requiredPrefix,
                    label))))),
        help && (react_1.default.createElement(typography_1.P, { pt: 1, color: colors_1.colors.gray600 }, help)),
        errorMessage && (react_1.default.createElement(typography_1.P, { pt: 1, error: true }, errorMessage))));
};
exports.FormField = FormField;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FormField.js.map